import { render, staticRenderFns } from "./ImportLiveTaskCard.vue?vue&type=template&id=34bc9288&scoped=true"
import script from "./ImportLiveTaskCard.vue?vue&type=script&lang=js"
export * from "./ImportLiveTaskCard.vue?vue&type=script&lang=js"
import style0 from "./ImportLiveTaskCard.vue?vue&type=style&index=0&id=34bc9288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc9288",
  null
  
)

export default component.exports